const radioContainer = document.querySelector('.routemap__buttons');
const loyperMap = document.querySelector('.routemap--loyper');
const routePanel = document.querySelector('.routepanel');
const typeSwitch = document.querySelector('.typeswitch');

if (radioContainer && loyperMap) {
    radioContainer.addEventListener('click', () => {
        const loyperMapActive = document.querySelector('#loyper-radio').checked;
        loyperMap.style.display = loyperMapActive ? 'block' : 'none';
        const mapElements = document.querySelectorAll('#routemap > div');
        for (let i=0; i<mapElements.length; i++) {
            mapElements[i].style.display = loyperMapActive ? 'none' : 'block';
            mapElements[i].style.display = loyperMapActive ? 'none' : 'block';
        }
        if (routePanel.classList.contains('routepanel--active')) {
            routePanel.classList.remove('routepanel--active');
            typeSwitch.firstChild.classList.add('typeswitch--active');
            typeSwitch.lastChild.classList.remove('typeswitch--active');
        }
    });
    typeSwitch.addEventListener('click', (e) => {
        typeSwitch.firstChild.classList.remove('typeswitch--active');
        typeSwitch.lastChild.classList.remove('typeswitch--active');
        e.target.classList.add('typeswitch--active');
    });
}

// Friluftspage

const toggles = document.querySelectorAll('[data-toggle-entry]');
const targets = document.querySelectorAll('[data-toggle-entry-target]');

if (toggles.length && targets.length) {
    for (let i = 0; i < toggles.length; i++) {
        const id = toggles[i].getAttribute('data-toggle-entry');
        if (!localStorage.getItem('id')) {
            localStorage.setItem('id', id);
        }
        toggles[i].addEventListener('click', () => {
            const toggleActiveClass = toggles[i].getAttribute('data-toggle-entry-class');
            if (toggles[i].classList.contains(toggleActiveClass)) {
                return;
            }
            toggle([toggles, targets], id);
            localStorage.setItem('id', id);
        });
    }
    const currentId = localStorage.getItem('id');
    if (currentId) {
        toggle([toggles, targets], currentId);
    }
}

function toggle(arrays, id) {
    for (const elements of arrays) {
        for (let j = 0; j < elements.length; j++) {
            const toggle = elements[j];
            toggle.classList.remove(toggle.getAttribute('data-toggle-entry-class'))
            if ( toggle.getAttribute('data-toggle-entry-target') === id || 
                 toggle.getAttribute('data-toggle-entry') === id) {
                toggle.classList.add(toggle.getAttribute('data-toggle-entry-class'));
            }
        }
    }
}